import { UPDATE_ITEM_INTENT } from "../../constants";
import { CLEAR_ERRORS } from "../../../common/constants";
import getIndicativeColourWayId from "./getIndicativeColourWayId";
import getIndicativeVariantId from "./getIndicativeVariantId";
import getIndicativePrice from "./getIndicativePrice";
import getIndicativeImageUrl from "./getIndicativeImageUrl";
import getIndicativeStock from "./getIndicativeStock";
import getIndicativeFulfilment from "./getIndicativeFulfilment";
import getIndicativeDiscount from "./getIndicativeDiscount";

const updateItemIntent =
  (
    {
      id,
      productId,
      isOneSize,
      isNoSize,
      selectedColourWayId,
      selectedVariantId,
      variants,
      images
    },
    extendedPayload = {}
  ) =>
  dispatch => {
    dispatch({ type: CLEAR_ERRORS });

    const indicativeColourWayId = getIndicativeColourWayId({
      selectedColourWayId
    });
    const indicativeVariantId = getIndicativeVariantId({
      isOneSize,
      isNoSize,
      selectedColourWayId,
      selectedVariantId,
      variants
    });
    const indicativePrice = getIndicativePrice({
      selectedColourWayId,
      selectedVariantId,
      variants
    });
    const indicativeImageUrl = getIndicativeImageUrl({
      selectedColourWayId,
      images
    });
    const indicativeStock = getIndicativeStock({
      selectedColourWayId,
      selectedVariantId,
      variants
    });

    const fulfilment = getIndicativeFulfilment({
      indicativeVariantId,
      variants
    });

    const discount = getIndicativeDiscount({
      selectedColourWayId,
      selectedVariantId,
      variants
    });

    return dispatch({
      type: UPDATE_ITEM_INTENT,
      payload: {
        id,
        productId,
        variantId: indicativeVariantId,
        fulfilment,
        discount,
        ...extendedPayload,
        ...indicativePrice,
        ...indicativeImageUrl,
        ...indicativeStock,
        ...indicativeColourWayId
      }
    });
  };

export default updateItemIntent;
